"use client";

import { useMemo } from "react";
import { useLanguage } from "./language-context";
import { getTranslations, t } from "./translations";

export function useTranslations() {
  const { nativeLanguage, targetLanguage, isLoaded } = useLanguage();

  const translations = useMemo(() => {
    return getTranslations(nativeLanguage.code);
  }, [nativeLanguage.code]);

  // Helper to interpolate target language name
  const withLanguage = useMemo(() => {
    const langName = targetLanguage.name.split(" ")[0] ?? targetLanguage.name;
    return {
      ...translations,
      // Pre-interpolated common strings
      grammarSubtitle: t(translations.grammar.subtitle, { language: langName }),
      grammarNoRulesDescription: t(translations.grammar.noRulesDescription, { language: langName }),
      alphabetSubtitle: t(translations.alphabet.subtitle, { language: langName }),
      alphabetComingSoonDescription: t(translations.alphabet.comingSoonDescription, { language: langName }),
    };
  }, [translations, targetLanguage.name]);

  return {
    ...translations,
    ...withLanguage,
    t, // Expose interpolation helper
    isLoaded,
  };
}
